<template>
  <div class="view pa24">
    <el-select class="main-select-tree" clearable @clear="setValueNull()" placeholder="请选择产品类别" ref="classRef"
      v-model="parentName" style="width: 400px;" name='option 1'>
      <el-option v-for="item in optionData(classList)" :label="item.label" :value="item.id" :key="item.id"
        style="display: none;" />
      <!-- 搜索参数 -->
      <div class="searchWrap">
        <div class="searchItem">
          <span class="searchName">名称</span>
          <el-input placeholder="输入名称关键字进行过滤" v-model="filterText" style="margin: 0 5px; width: 98%">
          </el-input>
        </div>
        <div class="searchItem">
          <span class="searchName">规格</span>
          <el-input placeholder="输入规格关键字进行过滤" v-model="specName" style="margin: 0 5px; width: 98%">
          </el-input>
        </div>
        <div class="searchItem">
          <span class="searchName">件号/存货编号</span>
          <el-input placeholder="输入规格关键字进行过滤" v-model="partNumber" style="margin: 0 5px; width: 98%">
          </el-input>
        </div>
        <div class="searchItem">
          <el-radio-group v-model="queryParam.classType" @change="handleClassTypeChange">
            <el-radio :label="1">原材料</el-radio>
            <el-radio :label="0">成品</el-radio>
          </el-radio-group>
        </div>
      </div>
      <el-tree class="main-select-el-tree" ref="selectelTree" :data="classList" :props='treeProps' highlight-current
        @node-click="(data, node, item) => handleNodeClick(data, node, item)" :expand-on-click-node="expandOnClickNode"
        collapse-tags :lazy="true" :load="load" />
    </el-select>
    <el-input v-model="queryParam.partNumber" placeholder="请输入件号/存货编码" class="mb10 ml10" style="width: 200px;">
    </el-input>
    <el-cascader clearable class="mb10 ml10" v-model="queryParam.warehouseId" placeholder="请选择仓库"
      :options="warehouseList" :emitPath="false" @change="chooseWaerhouse"
      :props="{value:'id',label:'name',children:'children', checkStrictly: true}"></el-cascader>
    <el-select v-model="queryParam.codeId" placeholder="请选择容器码" @focus="checkWarehouse" class="mb10 ml10"
      style="width: 290px">
      <el-option v-for="item in codeList" :key="item.id" :label="item.name+'/'+item.handle" :value="item.id">
      </el-option>
    </el-select>
    <el-date-picker class="mb10 ml10" v-model="times" type="datetimerange" :picker-options="pickerOptions"
      range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd" format="yyyy-MM-dd"
      @change="chooseTime" align="right">
    </el-date-picker>
    <el-button class="ml10 mb10" type="primary" @click="search">搜索</el-button>
    <el-button class="ml10 mb10" type="primary" @click="reset">重置</el-button>
  </div>
</template>
<script>
  import { pageClassList } from '@/api/customPageClass.js'
  import { fetchWarehouseTree } from '@/api/storeWarehouse.js'
  import { selectCode } from '@/api/storeCode'
  export default {
    name: 'search',
    components: {
    },
    props: {

    },
    data() {
      return {
        classList: [],
        queryParam: {
          classId: '',
          warehouseId: '',
          startTime: '',
          endTime: '',
          codeId: '',
          partNumber: '',
          classType: 1
        },
        warehouseList: [],
        codeList: [],
        times: [],
        pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
        },
        expandOnClickNode: false,
        treeProps: {
          children: 'children',
          label: 'allName',
          isLeaf: 'isLeaf'
        },
        parentName: '',
        allData: '',
        specName: "",
        partNumber: "",
        filterText: "",
        isInitialRender: true,
      };
    },
    created() {

    },
    watch: {
      filterText(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.queryParam.classType,
          parentId: "",
          name: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      specName(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.queryParam.classType,
          parentId: "",
          specName: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
      partNumber(val) {
        let params = {
          noPage: true,
          type: 0,
          classType: this.queryParam.classType,
          parentId: "",
          partNumber: val,
          pageNum: 1,
          pageSize: 200,
        };
        this.searchItem(params, val)
      },
    },
    mounted() {
      this.getAllClass()
      this.getWarehouseList()
    },
    methods: {
      searchItem(params, val) {
        pageClassList(params)
          .then((res) => {
            res.data.list.forEach((item) => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            });
            if (res.data.list && res.data.list.length == 0) {
              this.$message.error("没有找到相关的产品类别");
            }
            if (val) {
              this.classList =
                res.data.list && res.data.list.length > 0
                  ? res.data.list
                  : this.allData;
            } else {
              this.classList = this.allData;
            }
          })
          .catch((error) => {
            console.error("接口调用出错:", error);
          });
      },
      load(node, resolve) {
        console.log(node, 'aaaaaaaaaaa')
        if (this.isInitialRender) {
          this.isInitialRender = false;
          return resolve([]);
        }
        if ('顶级' == node.data.name || '顶级' == node.data.allName) {
          return resolve(node.data.children)
        } else {
          let params = {
            noPage: true,
            parentId: node.data.id,
            classType: this.queryParam.classType,
            pageNum: 1,
            pageSize: 200,
            name: this.filterText,
            specName: this.specName,
            partNumber: this.partNumber
          }
          pageClassList(params).then(res => {
            res.data.list.forEach(item => {
              item.isLeaf = !item.hasChildren;
              let namePart = item.name ? `${item.name}` : "";
              let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
              let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
              let specNamePart = item.specName ? `(${item.specName})` : "";
              item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
            })
            node.data.children = res.data.list;
            return resolve(res.data.list)
          })
        }

      },
      setValueNull() {
        this.queryParam.classId = ''
        this.parentName = ''
      },
      getAllClass() {
        let params = {
          pageNum: 1,
          pageSize: 200,
          type: 0,
          classType: this.queryParam.classType,
        }
        pageClassList(params).then(res => {
          res.data.list.forEach((item) => {
            item.isLeaf = !item.hasChildren;
            let namePart = item.name ? `${item.name}` : "";
            let inventCodePart = item.inventCode ? `(${item.inventCode})` : "";
            let modelNoPart = item.modelNo ? `(${item.modelNo})` : "";
            let specNamePart = item.specName ? `(${item.specName})` : "";
            item.allName = `${namePart}${inventCodePart}${modelNoPart}${specNamePart}`;
          });
          this.classList = [{ id: '', allName: '顶级', children: res.data.list }]
          this.allData = JSON.parse(JSON.stringify(this.classList));
          this.$forceUpdate();
        })
      },
      reset() {
        this.queryParam.classId = ''
        this.queryParam.warehouseId = ''
        this.queryParam.startTime = ''
        this.queryParam.endTime = ''
        this.queryParam.codeId = ''
        this.times = []
        this.parentName = ''
        this.queryParam.partNumber = ''
        this.queryParam.classType = 1
        this.search()
      },
      getWarehouseList() {
        fetchWarehouseTree().then(res => {
          this.warehouseList = res.data
        })
      },
      chooseWaerhouse(val) {
        if (val) {
          this.queryParam.warehouseId = val[val.length - 1]
          this.getAllCode()
        }
      },
      chooseTime(val) {
        if (val) {
          this.queryParam.startTime = val[0]
          this.queryParam.endTime = val[1]
        }
      },
      getAllCode() {
        selectCode({ warehouseId: this.queryParam.warehouseId, isMaterial: false }).then(res => {
          if (res.data) {
            this.codeList = res.data
            this.queryParam.codeId = ''
          }
        })
      },
      checkWarehouse() {
        if (!this.queryParam.warehouseId) {
          this.$message.error("请先选择仓库")
          return false
        }
      },
      search() {
        this.$emit('search', this.queryParam)
      },
      optionData(array, result = []) {
        array.forEach(item => {
          result.push({
            label: item.specName ? item.name + "(" + item.specName + ")" : item.name,
            value: item.id
          })
          if (item.children && item.children.length !== 0) {
            this.optionData(item.children, result)
          }
        })
        return JSON.parse(JSON.stringify(result))
      },
      handleNodeClick(data, node, item) {
        this.queryParam.classId = data.id
        this.parentName = data.allName
        this.$refs.classRef.blur();
      },
      handleClassTypeChange() {
        this.queryParam.classId = ''
        this.parentName = ''
        this.getAllClass()
      }
    },
  }
</script>
<style scoped lang="scss">
  .searchItem {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
    padding-left: 10px;
    padding-right: 10px;

    .searchName {
      width: 130px;
      font-size: 14px;
    }
  }
</style>